define('lq/formatting',[
    'jquery',
    'underscore',
    'lq/formatter',
    'lq/util'
], function ($, _, Formatter, util) {
	'use strict';

	var defaultFormatting = {
		id: null,
		name: '',
		dateFormat: 'yyyy-MM-dd',
		decimalSeperator: '.',
		groupSeperator: ',',
		decimalPrecision: 2
	};
    
    var Formatting = function (data, userLanguage) {
        this.defaultFormattingId = data.defaultFormattingId;
        this.formattersById = {};
        this.defaultFormatter = null;
        this.fallbackFormatter = null;
        this.formattingSettings = util.cloneData(data);

        this.userLanguage = userLanguage;
        
        if (data.formattings !== null && data.formattings !== undefined && data.formattings !== '')
            _.each(data.formattings, this.addFormatting.bind(this));

        this.fallbackFormatter = new Formatter(defaultFormatting, this.userLanguage);
    };

    Formatting.prototype.addFormatting = function (formatting) {
        formatting = util.convertListOfKeyValuesToObject(formatting);
        formatting = $.extend(true, {}, defaultFormatting, formatting);

        var formatter = this.createFormatter(formatting);
        this.formattersById[formatting.id] = formatter;

        if (formatting.id === this.defaultFormattingId)
            this.defaultFormatter = formatter;
    };
    
    Formatting.prototype.getAvailableFormattings = function () {
        return util.cloneData(this.formattingSettings.formattings);
    };

    Formatting.prototype.getSettings = function () {
        return util.cloneData(this.formattingSettings);
    };

    Formatting.prototype.getFallbackFormatting = function () {
        return util.cloneData(defaultFormatting);
    };
    
    Formatting.prototype.createFormatter = function (formatting) {
        if (!formatting)
            return this.defaultFormatter || this.fallbackFormatter;

        if (formatting.constructor === String)
            return this.formattersById[formatting] || this.fallbackFormatter;

        formatting = util.convertListOfKeyValuesToObject(formatting);
        formatting = $.extend(true, {}, defaultFormatting, formatting);
        
        // todo find out why this fallback was built-in
        formatting.decimalSeperator = formatting.decimalSeperator || defaultFormatting.decimalSeperator; // always required to have a decimal separator

        return new Formatter(formatting, this.userLanguage);
    };

    return Formatting;
});
